import { getDialogHooks } from 'utilities/dialog-context/DialogContextHelpers';
import {
  TextConsentsDialog,
  TextConsentsDialogCallbackInput,
  TextConsentsDialogUniqueProps,
} from '../message/TextConsentsDialog';

const { useDialogForContext, useDialog: useTextConsentsDialog } =
  getDialogHooks<
    TextConsentsDialogUniqueProps,
    TextConsentsDialogCallbackInput
  >(TextConsentsDialog);

export const useTextConsentsDialogForContext = useDialogForContext;
export default useTextConsentsDialog;
